import styled, { css } from 'styled-components';
import { px2rem } from '../../helpers/style.js';
import { styles } from '../../../constants/styles.js';
import { fontFamilyStyles } from '../../../ContentText/styles.web.js';
import { boxStyles } from '../../../Box/styles.js';
import { boxPropExclusions } from '../../../Box/props.js';

var label = /*#__PURE__*/styled.label.withConfig({
  displayName: "styles__label",
  componentId: "sc-f9ypg9-0"
})(["cursor:pointer;display:flex;"]);
var focusVisibleStyle = /*#__PURE__*/css(["outline-offset:-2px;outline:2px solid ", ";", " "], function (p) {
  return p.theme.tokens.focus.primary;
}, boxStyles /* additional border radius if present */);
var itemFocusVisible = /*#__PURE__*/css(["", " &:focus-visible{", "}&:focus:not(:focus-visible){outline:none;}"], function (props) {
  return props.$focusVisible && focusVisibleStyle;
}, focusVisibleStyle);
var textLabel = /*#__PURE__*/styled.span.withConfig({
  displayName: "styles__textLabel",
  componentId: "sc-f9ypg9-1"
})(["color:", ";font-size:", ";display:block;overflow:hidden;line-height:", ";text-overflow:ellipsis;white-space:", ";"], function (props) {
  return props.$highlight ? props.theme.listItems.web.autocompleteText.normal : props.theme.listItems.web.textColor;
}, function (p) {
  return p.theme.listItems.web.sizings[p.$size].fontSize;
}, function (p) {
  return p.theme.listItems.web.sizings[p.$size].lineHeight;
}, function (props) {
  return props.$whiteSpace;
});
var item = /*#__PURE__*/styled.li.withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return !boxPropExclusions.has(prop);
  }
}).withConfig({
  displayName: "styles__item",
  componentId: "sc-f9ypg9-3"
})(["", ";box-sizing:border-box;list-style:none;outline:none;transition:opacity ", ",transform ", ";transition-timing-function:", ";transition-delay:", "ms;border-top:2px solid transparent;border-bottom:2px solid transparent;padding:0 ", ";", " ", ""], fontFamilyStyles, styles.transition.timing.faster, styles.transition.timing.faster, styles.transition["function"].base, function (props) {
  return props.$delay || 0;
}, function (p) {
  return p.$disableBorders ? p.theme.listItems.web.paddingHorizontal : "calc(".concat(p.theme.listItems.web.paddingHorizontal, " - ").concat(px2rem(p.theme.listItems.web.borders.width), ")");
}, function (props) {
  return props.$active && css(["background-color:", ";", "{color:", ";}", ";"], function (p) {
    return p.theme.listItems.web.active;
  }, textLabel, function (props) {
    return props.$highlight && props.theme.listItems.web.autocompleteText.hover;
  }, itemFocusVisible);
}, function (props) {
  return props.$selectedHighlight && css(["> ", "{font-weight:", ";}"], label, styles.fontWeight.bold);
});
var list = /*#__PURE__*/styled.ul.withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return !boxPropExclusions.has(prop);
  }
}).withConfig({
  displayName: "styles__list",
  componentId: "sc-f9ypg9-4"
})(["box-sizing:border-box;list-style:none;line-height:1;margin:0;padding:0;background:", ";", " border-top:0;border-bottom:0;top:", ";transform:", ";overflow:hidden;position:relative;transition-property:max-height,border-color,z-index,opacity;transition-timing-function:", ";transition-duration:", "ms;width:100%;&::-webkit-scrollbar{background:", ";width:", ";}&::-webkit-scrollbar-track{background:", ";box-shadow:none;}&::-webkit-scrollbar-thumb{background-color:", ";border:", " solid ", ";box-shadow:none;border-radius:", ";}&[aria-hidden='true']{max-height:0;opacity:0;z-index:3;}&[aria-hidden='false']{max-height:", ";opacity:1;z-index:100;}scrollbar-width:thin;scrollbar-color:", ";", " ", ""], function (props) {
  return props.theme.listItems.web.background;
}, function (props) {
  return !props.$disableBorders && css(["border:", " solid ", ";"], px2rem(props.theme.listItems.web.borders.width), props.$color);
}, function (props) {
  return props.$offset ? px2rem(props.$offset) : 0;
}, function (props) {
  return !props.$disableBorders && "translateY(".concat(px2rem(-2), ")");
}, styles.transition["function"].base, function (props) {
  return props.$transitionDuration;
}, function (props) {
  return props.theme.listItems.web.background;
}, px2rem(8), function (props) {
  return props.theme.listItems.web.background;
}, function (props) {
  return props.$color;
}, px2rem(2), function (props) {
  return props.theme.listItems.web.background;
}, function (p) {
  return p.theme.borders.radius;
}, function (p) {
  return p.$maxHeight;
}, function (props) {
  return "".concat(props.$color, " ").concat(props.theme.listItems.web.background);
}, boxStyles /** Manually override border-radius for top left/right */, function (props) {
  return !props.$disableBorders && css(["border-top-right-radius:0;border-top-left-radius:0;border-bottom-right-radius:0;border-bottom-left-radius:0;"]);
});
var appender = /*#__PURE__*/styled.div.withConfig({
  displayName: "styles__appender",
  componentId: "sc-f9ypg9-5"
})(["position:relative;border:", ";border-top:0;background:", ";top:", "px;z-index:100;", ""], function (props) {
  return "".concat(px2rem(props.theme.listItems.web.borders.width), " solid ").concat(props.$color);
}, function (props) {
  return props.theme.listItems.web.background;
}, function (props) {
  return -2 + (props.$offset || 0);
}, function (props) {
  return (
    // when select is open we need only bottom border
    props.$borderRadius && parseFloat(String(props.$borderRadius)) > 0 && css(["border-bottom-right-radius:", ";border-bottom-left-radius:", ";height:calc(", " + 3px);"], props.$borderRadius, props.$borderRadius, props.$borderRadius)
  );
});

export { appender, item, label, list, textLabel };
